export default __webpack_public_path__ + "integrateLogo_white.svg";